import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {setPromptVariable} from "@khan/guide-core-helpers";

// eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
import type {AITeacherTools_ArticleDetailsType} from "./__graphql-types__/index.ts";
import {unsetSharedDetails} from "./shared-details.ts";

export const ARTICLE_DETAILS_QUERY: GqlOperation<
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ArticleDetailsType["response"],
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_ArticleDetailsType["variables"]
> = gqlOp(gql`
    query AITeacherTools_ArticleDetails($articleId: String) {
        articleById(id: $articleId) {
            id
            translatedTitle
            defaultUrlPath
            translatedPerseusContent
            parentTopic {
                id
                domainSlug
                allLearnableContent(includeUnlisted: false) {
                    id
                    translatedTitle
                    defaultUrlPath
                }
            }
        }
    }
`);

export function unloadArticleDetails() {
    ["contentTitle", "context", "domain", "articleContent"].forEach(
        (variable) => {
            setPromptVariable(variable, null);
        },
    );
    unsetSharedDetails();
}
